import {
  createOrganisationDtoFromAdminOrganisationModel,
  OrganisationModel,
} from "./organisation";
import { SellerDto } from "@vini-wine/core-dtos";

export interface SellerModel {
  // available includes
  organisation?: OrganisationModel;
}

export const createSellerDtoFromAdminSellerModel = (
  seller: SellerModel,
): SellerDto => {
  return {
    uuid: seller.organisation ? seller.organisation.uuid : "Not found",
    name: seller.organisation?.name,
    organisation: seller.organisation
      ? createOrganisationDtoFromAdminOrganisationModel(seller.organisation)
      : undefined,
  };
};
